import { defineStore } from 'pinia'

import type { CustomerStore } from '@stores/me/customer/interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCustomerStore = defineStore('customer', {
  state: (): CustomerStore => ({
    customer: null,
    status: 'idle',
    updatedAt: 0,
    _inFlight: null,
    _analyticsFirstSuccessInit: false,
    clarityReady: false,
  }),
  actions,
  getters,
})
